//----- CURRENT LOCATION ON ROUTE POLYLINE --------------------------------------------------------------------------------------------------------------------------------------------
const SOLID_POLYLINE_DEFAULTS = {
  strokeColor: '#0072CE',
  strokeOpacity: 1,
  strokeWeight: 6,
  zIndex: 2
};
const BORDER_POLYLINE_DEFAULTS = {
  strokeColor: '#FFFFFF',
  strokeOpacity: 1,
  strokeWeight: 10,
  zIndex: 1
};

export const SOLID_POLYLINE = (overrides = {}): google.maps.PolylineOptions => ({
  ...SOLID_POLYLINE_DEFAULTS,
  ...overrides
});

export const BORDER_POLYLINE = (overrides = {}): google.maps.PolylineOptions => ({
  ...BORDER_POLYLINE_DEFAULTS,
  ...overrides
});

//----- REMAON ROUTE POLYLINE --------------------------------------------------------------------------------------------------------------------------------------------
const REMAIN_DOTTED_DEFAULTS = {
  scale: 4,
  fillColor: '#000000',
  fillOpacity: 1,
  strokeOpacity: 0
}

export const REMAIN_DOTTED_POLYLINE = (overrides = {}): google.maps.PolylineOptions => ({
  strokeOpacity: 0,
  icons: [
    {
      icon: {
        path: google.maps.SymbolPath.CIRCLE,
        ...REMAIN_DOTTED_DEFAULTS,
        ...overrides
      },
      offset: '0',
      repeat: '10px'
    }
  ]
});

//----- FINISHED ROUTE POLYLINE --------------------------------------------------------------------------------------------------------------------------------------------
const FINISHED_DOTTED_DEFAULTS = {
  scale: 4,
  fillColor: '#888888',
  fillOpacity: 1,
  strokeOpacity: 0
}

export const FINISHED_DOTTED_POLYLINE = (overrides = {}): google.maps.PolylineOptions => ({
  strokeOpacity: 0,
  icons: [
    {
      icon: {
        path: google.maps.SymbolPath.CIRCLE,
        ...FINISHED_DOTTED_DEFAULTS,
        ...overrides
      },
      offset: '0',
      repeat: '10px'
    }
  ]
});
